module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "showPlan"
    }
  }, [_c('div', {
    staticClass: "trainGames clearfix"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "padding-left": "10px",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "evalItem evalItem-showplan u-addMore u-addMore-showplan",
    staticStyle: {
      "padding": "0",
      "margin": "20px 0 20px 30px"
    },
    on: {
      "click": _vm.addMore
    }
  }), _vm._v(" "), _vm._l((_vm.games), function(game, index) {
    return _c('div', {
      staticClass: "evalItem evalItem-showplan",
      staticStyle: {
        "padding": "20px 0"
      }
    }, [_c('div', {
      staticClass: "board pointer board-showplan",
      on: {
        "click": function($event) {
          _vm.selectGame(game)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "src": _vm.address + game.image
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "m-mask m-mask-showplan"
    }, [_c('span', {
      staticClass: "u-close",
      on: {
        "click": function($event) {
          _vm.deleteHandler(game, index)
        }
      }
    }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
      staticClass: "boardName"
    }, [_vm._v(_vm._s(game.name))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-top": "-17px"
      }
    }, [_c('level', {
      attrs: {
        "level": game.level
      }
    })], 1)])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b8e5c5c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/case/trainPlan/showPlan.vue
// module id = 1025
// module chunks = 2